// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TFHz7","dotsContainer":"styles_dotsContainer__v5wsd","dot":"styles_dot__qwQhk","dotActive":"styles_dotActive__xN0Vv"};